<template>
    <label class="variant-radio">
        <input type="radio" name="options[framed]" :value="inputValue" :checked="inputValue == value" @change="update">
        <span class="variant-radio__name">
            <slot></slot>
        </span>
    </label>
</template>

<script>
    export default {
        props: {
            value: {
                required: true,
            },
            inputValue: {
                required: true,
            },
            price: {
                required: true,
            }
        },
        methods: {
            update(event) {
                this.$emit('input', event.target.value);
            }
        }
    }
</script>

<style scoped>

</style>